import React from 'react';
import { useBoardState } from '../../context/BoardContext';
import { Header, OperationStatusIndicator } from '../Common';
import { KanbanBoard } from './';
import { TaskContainer } from '../Task';
import AgendaView from './AgendaView';

const BoardContent = ({ currentView, setCurrentView }) => {
  const { operationStatus } = useBoardState();

  return (
    <div className="task-board jira-board-app">
      <Header currentView={currentView} setCurrentView={setCurrentView} />
      {currentView === 'kanban' ? <KanbanBoard /> : <AgendaView currentView={currentView} />}
      <TaskContainer />
      <OperationStatusIndicator operationStatus={operationStatus} />
    </div>
  );
};

export default React.memo(BoardContent);
